<template>
  <v-container>
    <v-expansion-panels v-if="plan.tiers && plan.tiers.length>0">
      <v-expansion-panel>
        <v-expansion-panel-header>{{lang.prices}}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list class="scroll_type" dense subheader max-height="160" style="overflow:auto">
            <v-list-item v-for="(tier,i) in plan.tiers" :key="i">
              <v-list-item-content>
                <v-list-item-title>{{tier.unit_amount/100}} {{getCurrency(plan.currency)}}</v-list-item-title>
                <v-list-item-subtitle v-if="tier.up_to==0">{{lang.upto}} ∞ {{lang.displays}}</v-list-item-subtitle>
                <v-list-item-subtitle v-else>{{lang.upto}} {{tier.up_to}} {{lang.displays}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-list v-else dense subheader max-height="160" style="overflow:auto">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{lang.price}} : {{plan.amount/100}} {{getCurrency(plan.currency)}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  components: {},
  props: {
    plan: Object
  },

  computed: {
    ...mapState(["lang"])
  },
  mounted() {},
  methods: {
    getCurrency(currency) {
      switch (currency) {
        case "usd":
          return this.lang.dollars;
        case "aud":
          return this.lang.au_dollars;
      }
      return currency;
    }
  }
};
</script>

